import client from '../utils/client';

export const getAddresses = async (params) => {
    return (await client('/apps/hb-cp/api/users/me/addresses/recipients', {params}));
}

export const saveAddress = async (payload,params) => {
    return await client.post('/apps/hb-cp/api/users/me/addresses/recipients', payload, {params});
}